import { render, staticRenderFns } from "./MessageSession.vue?vue&type=template&id=09561d8b"
import script from "./MessageSession.vue?vue&type=script&lang=js"
export * from "./MessageSession.vue?vue&type=script&lang=js"
import style0 from "./MessageSession.vue?vue&type=style&index=0&id=09561d8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports